"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _Button = _interopRequireDefault(require("../../control-components/ui-components/Button"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'events-statistics-bar';
exports.cssAnchorName = cssAnchorName;

var GuestButton = function GuestButton() {
  var openLoginPopUp = function openLoginPopUp() {
    var event = new CustomEvent('GuestUserAction');
    window.dispatchEvent(event);
  };

  return (0, _preact.h)(_Button.default, {
    toggle: true,
    onClick: openLoginPopUp
  }, (0, _preact.h)(_phrase.default, {
    p: "events.subscribe.to.updates"
  }));
};

var SubscribeButton = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SubscribeButton, _Component);

  var _super = _createSuper(SubscribeButton);

  function SubscribeButton() {
    var _this;

    (0, _classCallCheck2.default)(this, SubscribeButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isSubscribed: false,
      isLoading: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "checkSubscription", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var result, isSubscribed;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _axios.default.get('/events/subscription');

            case 2:
              result = _context.sent;
              isSubscribed = result.data;

              _this.setState({
                isSubscribed: isSubscribed
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleSubscription", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var isSubscribed;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.setState({
                isLoading: true
              });

              isSubscribed = _this.state.isSubscribed;
              _context2.prev = 2;

              if (!isSubscribed) {
                _context2.next = 8;
                break;
              }

              _context2.next = 6;
              return _axios.default.delete('/events/subscription');

            case 6:
              _context2.next = 10;
              break;

            case 8:
              _context2.next = 10;
              return _axios.default.post('/events/subscription');

            case 10:
              _this.setState({
                isSubscribed: !isSubscribed
              });

            case 11:
              _context2.prev = 11;

              _this.setState({
                isLoading: false
              });

              return _context2.finish(11);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2,, 11, 14]]);
    })));
    return _this;
  }

  (0, _createClass2.default)(SubscribeButton, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.checkSubscription();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var state = this.state;
      return (0, _preact.h)(_Tooltip.default, {
        customClasses: "events_subscribe-btn--message",
        trigger: (0, _preact.h)(_Button.default, {
          loading: state.isLoading,
          toggle: true,
          toggleActive: state.isSubscribed,
          onClick: this.toggleSubscription
        }, state.isSubscribed ? (0, _preact.h)(_phrase.default, {
          p: "events.subscribed.to.updates"
        }) : (0, _preact.h)(_phrase.default, {
          p: "events.subscribe.to.updates"
        })),
        tooltipMessage: (0, _preact.h)(_phrase.default, {
          p: "events.subscribe.tooltip"
        })
      });
    }
  }]);
  return SubscribeButton;
}(_preact.Component);

var StatisticsBar = /*#__PURE__*/function (_Component2) {
  (0, _inherits2.default)(StatisticsBar, _Component2);

  var _super2 = _createSuper(StatisticsBar);

  function StatisticsBar() {
    var _this2;

    (0, _classCallCheck2.default)(this, StatisticsBar);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "state", {
      totalEventsCount: null
    });
    return _this2;
  }

  (0, _createClass2.default)(StatisticsBar, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getEventsCount();

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function componentDidMount() {
        return _componentDidMount2.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "getEventsCount",
    value: function () {
      var _getEventsCount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        var result;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _axios.default.get('/event/eventsCount');

              case 2:
                result = _context5.sent;
                this.setState({
                  totalEventsCount: result.data.totalEventsCount
                });

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getEventsCount() {
        return _getEventsCount.apply(this, arguments);
      }

      return getEventsCount;
    }()
  }, {
    key: "render",
    value: function render() {
      var isGuest = this.props.isGuest;
      var totalEventsCount = this.state.totalEventsCount;
      var counterPhraseCount = typeof totalEventsCount === 'number' ? "".concat(totalEventsCount) : '';
      return (0, _preact.h)("section", {
        className: "full-width Template-brand-stats custom-stats-bar"
      }, (0, _preact.h)("div", {
        className: "stats-bar p-v qa-stats-bar"
      }, (0, _preact.h)("div", {
        className: "sitewidth"
      }, (0, _preact.h)("div", {
        className: "col"
      }, (0, _preact.h)("ul", {
        className: "list list--stats-bar qa-stats-bar"
      }, totalEventsCount ? (0, _preact.h)("li", {
        className: "list__item"
      }, (0, _preact.h)("strong", null, totalEventsCount), (0, _preact.h)("span", null, (0, _preact.h)(_phrase.default, {
        p: "events.total.events.counter",
        count: {
          n: counterPhraseCount
        }
      }))) : null), isGuest ? (0, _preact.h)(GuestButton, null) : (0, _preact.h)(SubscribeButton, null)))));
    }
  }]);
  return StatisticsBar;
}(_preact.Component);

var _default = StatisticsBar;
exports.default = _default;